import distributionWarehouseBrands from "@/GeneratedFixtures/DistributionWarehouseBrands.json";

// Some warehouses don't have a delivery without a date — Walmart works to the PO
// date. Asking those as a yes/no just lets the date go missing, so the booking
// screen shows a required date field instead of a toggle.
// An unrecognized brand can't be known to require one, so it doesn't.
export function getDistributionWareHouseRequiresDeliveryDeadline(
  distributionWarehouseBrand: string | undefined,
): boolean {
  return (
    distributionWarehouseBrands.find(
      (d) => d.identifier === distributionWarehouseBrand,
    )?.requiresDeliveryDeadline === true
  );
}
